import { CardContainerSm } from '@apps-common/components/common/CardContainerSm'
import { ButtonRoundSm } from '@apps-common/components/elements'

interface IProps {
  Icon: any
  children: React.ReactNode
}

export const DashNoResultsCard: React.FC<IProps> = ({ Icon, children }) => {
  return (
    <CardContainerSm bgClasses='bg-surface p-6 flex flex-col gap-[15px] text-text border border-border'>
      <ButtonRoundSm type='div' className='min-w-[40px] min-h-[40px] rounded-full bg-surface-2 border border-border'>
        <Icon className='text-[1.45em]' />
      </ButtonRoundSm>
      <p className='jost text-[0.9rem] flex flex-col gap-1'>
        Nothing to show here.
        <br />
        <span className='jost-light'>{children}</span>
      </p>
    </CardContainerSm>
  )
}
